<template src="../../../../components/shared/physicianSearch/BaseSearchResultTemplate.html">

</template>

<script>
    import {baseResultMixin} from "../../../../components/shared/mixins/baseResultMixin.js";
    import {mapGetters} from "vuex";
    import {common} from "../../../../global/common.js";

    export default {
        name: "SearchResult",
        mixins: [baseResultMixin],
        data() {
            return {
                //We can not pass it as a prop because the html is being shared
                companyId: this.additionalData.companyId,
                token: this.additionalData.token
            };
        },
        computed: {
            ...mapGetters({showPricing: 'globalSettings/showPricing'}),
            ...mapGetters({showVirtualPlans: 'globalSettings/showVirtualPlans'})
        },
        async mounted() {
            let detailsUrl = `ProviderSearch/${this.companyId}/getProviderDetailsAndPlans/${this.baseData.providerEntityId}`;
            detailsUrl = common.appendUrlParameter(detailsUrl, 'token', this.token);
            await this.baseInit(detailsUrl);
        },
        methods: {
            viewProfile() {
                const planCategoryId = this.$route.query.planCategoryId;
                this.$router.push({
                    name: "providerProfile",
                    params: {
                        ...this.additionalData,
                        providerEntityId: this.baseData.providerEntityId
                    },
                    ...(planCategoryId != null && planCategoryId !== ''
                        ? {query: {planCategoryId}}
                        : {})
                });
            }
        }
    }
</script>

<style scoped>
    .view-map-link:hover {
        color: white;
        text-decoration: underline;
    }

    @keyframes placeHolderShimmer {
        0% {
            background-position: -468px 0
        }
        100% {
            background-position: 468px 0
        }
    }

    .loading-background {
        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeHolderShimmer;
        animation-timing-function: linear;
        background: #f6f7f8;
        background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
        background-size: 1000px 104px;
        height: 170px;
        position: relative;
        overflow: hidden;
    }

    .wl-dark-panel li {
        margin-bottom: 5px;
    }

    .wl-dark-panel li i {
        margin-right: 5px;
    }

    .ac-white-panel img {
        max-height: 120px;
    }

    .provider-left {
        border-radius: 15px 0 0 15px;
    }

    .provider-right {
        border-radius: 0 15px 15px 0;
    }

    @media (max-width: 975px) {
        .provider-left {
            border-radius: 15px 15px 0 0;
            display: flex;
            justify-content: center;
        }

        .provider-right {
            border-radius: 0 0 15px 15px;
            display: flex;
            justify-content: center;
        }
    }
</style>